import { I18n } from '@calendly/i18n'
import { Item } from '@calendly/ui/components/menu'

import { useGetUserQuery } from 'common'
import { openChat } from 'components/external/ada_chat_bot'
import { Segment } from 'core/analytics/segment'

import { ChatIcon } from './icons'

const ChatButton = ({ children }) => {
  const { data: currentUser } = useGetUserQuery()

  const handleClick = () => {
    openChat()
    Segment.track('help_menu.ask_question_clicked', { user_id: currentUser.id })
  }

  return (
    <Item role="menuitem" onClick={handleClick}>
      {children}
    </Item>
  )
}

export const DesktopChatButton = () => (
  <ChatButton>
    <ChatIcon />
    {I18n.t('publisher.menu.help_menu.chat_with_us')}
  </ChatButton>
)
